import React from 'react'
import './User_SetNameState.css'
import '../UserPanel.css'
import agent from "../../../agent";

class User_SetGoalState extends React.Component {
  setGoal(index, text) {
    let goals = this.props.goals;
    goals[index] = text;
    this.props.updateGoals(goals);
  }

  sendGoals() {
    agent.Game.setGoals(this.props.team.uuid, this.props.goals, resp => {
      console.log(resp)
    });
  }

  render() {
    let mainStyle = {
      "paddingTop": "100px",
      "paddingLeft": "100px",
      "width": "1400px",
      "height": "281px",
      "display": "flex",
      "flexDirection": "column",
      "justifyContent": "space-between",
      "alignItems": "flex-start"
    };
    let textStyle = {
      "width": "100%",
      "height": "80px",
      "fontFamily": "Mont",
      "fontSize": "30px",
      "textAlign": "left",
      "paddingTop": "20px"
    }
    let inputStyle = {
      width: "500px", height: "120px", marginTop: "20px", marginLeft: "5px"
    }

    const inputs = [0, 1, 2];
    return <div style={mainStyle}>
      <div className='user-header-text'>Цели команды</div>
      <div style={textStyle}>Обсудите и запишите цели команды. <br/>
        По готовности сообщите преподавателю.
      </div>
      {
        inputs.map((el, i) => {
          const theValue = {};
          const isActive = document.activeElement === document.querySelector('.inp-' + i);
          const paramName = isActive ? 'defaultValue' : 'value';
          theValue[paramName] = this.props.goals[i];

          return <div key={'goal-' + i} className='user-panel-container-input' style={inputStyle}>
                <textarea
                  className={`user-panel-input-field inp-${i}`}
                  placeholder={`Цель ${i + 1}`}
                  onInput={(ev) => this.setGoal(i, ev.currentTarget.value)}
                  onKeyDown={(ev) => {
                    if (ev.code === 'Enter') this.sendGoals();
                  }}
                  onBlur={this.sendGoals.bind(this)}
                  {...theValue}
                />
          </div>
        })
      }
    </div>
  }
}

export default User_SetGoalState;
